const currenciesEnum = require('../../../enums/currencies').enum;

module.exports = {
	getCurrencyIcon: function (currency) {
		switch (currency) {
			case currenciesEnum.rub:
				return '₽';
			case currenciesEnum.usd:
				return '$';
			case currenciesEnum.idr:
				return 'Rp';
			case currenciesEnum.byn:
				return 'Br';
			case currenciesEnum.kzt:
				return '₸';
			case currenciesEnum.mdl:
				return 'L';
			case currenciesEnum.azn:
				return '₼';
			case currenciesEnum.gel:
				return '₾';
			case currenciesEnum.bef:
				return 'bef';
			case currenciesEnum.omr:
				return 'omr';
			case currenciesEnum.sek:
				return 'sek';
			case currenciesEnum.uah:
				return '₴';
			case currenciesEnum.ron:
				return 'L';
			case currenciesEnum.kgs:
				return 'сом';
			case currenciesEnum.thb:
				return '฿';
			case currenciesEnum.amd:
				return '֏';
			case currenciesEnum.eur:
				return '€';
			case currenciesEnum.uzs:
				return 'сўм';
			case currenciesEnum.huf:
				return 'Ft';
			case currenciesEnum.pln:
				return 'zł';
			case currenciesEnum.bgn:
				return 'лв';
			case currenciesEnum.czk:
				return 'крон';
			case currenciesEnum.hrk:
				return 'Kn';
			case currenciesEnum.sgd:
				return 'S$';
			case currenciesEnum.cdf:
				return 'cdf';
			case currenciesEnum.zar:
				return 'R';
			case currenciesEnum.rwf:
				return 'rwf';
			case currenciesEnum.kes:
				return 'kes';
			case currenciesEnum.clp:
				return 'clp';
			case currenciesEnum.cfa:
				return 'cfa';
			case currenciesEnum.vnd:
				return '₫';
			case currenciesEnum.myr:
				return 'myr';
			case currenciesEnum.lbp:
				return 'ل.ل.';
			case currenciesEnum.ngn:
				return '₦';
			case currenciesEnum.aed:
				return 'د.إ';
			case currenciesEnum.kwd:
				return 'د.ك';
			case currenciesEnum.sar:
				return 'sar';
			case currenciesEnum.cop:
				return 'cop';
			case currenciesEnum.inr:
				return '₹';
			case currenciesEnum.bdt:
				return '৳';
			case currenciesEnum.twd:
				return 'NT$';
			case currenciesEnum.mmk:
				return 'K';
			case currenciesEnum.php:
				return '₱';
			case currenciesEnum.lkr:
				return '₨';
			case currenciesEnum.jod:
				return 'jod';
			case currenciesEnum.mxn:
				return 'mxn';
			case currenciesEnum.bhd:
				return 'bhd';
			case currenciesEnum.all:
				return 'lekë';
			case currenciesEnum.try:
				return '₺';
			case currenciesEnum.brl:
				return 'R$';
			case currenciesEnum.gtq:
				return 'Q';
			case currenciesEnum.bob:
				return 'Bs';
			case currenciesEnum.sol:
				return 'S/';
			case currenciesEnum.qar:
				return 'ر.ق';
			case currenciesEnum.ars:
				return 'ars';
			case currenciesEnum.iqd:
				return 'iqd';
			case currenciesEnum.chf:
				return 'chf';
			case currenciesEnum.nio:
				return 'C$';
			default:
				return '-';
		}
	}
};



// WEBPACK FOOTER //
// ./frontend/shared/js/get-currency-icon.js